/**
 * Hoffmaster Tabs Image Background Widget Handler
 * Handles tab switching, background image changes, and arrow navigation.
 */

class HoffmasterTabsImageBackgroundHandler extends elementorModules.frontend.handlers.Base {
	getDefaultSettings() {
		return {
			selectors: {
				tabLink: '.hm-tabs-full-width__tabs-links__item__anchor',
				tabContainer: '.hm-tabs-full-width__tabs-container',
				bgImage: '.hm-tabs-full-width__image-bg__img',
				prevBtn: '.hm-tabs-full-width__arrow--prev',
				nextBtn: '.hm-tabs-full-width__arrow--next',
			},
		};
	}

	getDefaultElements() {
		const selectors = this.getSettings('selectors');
		return {
			$tabLinks: this.$element.find(selectors.tabLink),
			$tabContainers: this.$element.find(selectors.tabContainer),
			$bgImages: this.$element.find(selectors.bgImage),
			$prevBtn: this.$element.find(selectors.prevBtn),
			$nextBtn: this.$element.find(selectors.nextBtn),
		};
	}

	bindEvents() {
		this.currentIndex = 0;
		this.totalTabs = this.elements.$tabLinks.length;

		// Tab link click handlers
		this.elements.$tabLinks.each((index, link) => {
			const $link = jQuery(link);

			$link.on('click', (e) => {
				e.preventDefault();
				this.switchToTab(index);
			});

			// Keyboard accessibility
			$link.on('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					this.switchToTab(index);
				}
			});
		});

		// Arrow navigation
		if (this.elements.$prevBtn.length) {
			this.elements.$prevBtn.on('click', () => {
				if (this.currentIndex > 0) {
					this.switchToTab(this.currentIndex - 1);
				}
			});
		}

		if (this.elements.$nextBtn.length) {
			this.elements.$nextBtn.on('click', () => {
				if (this.currentIndex < this.totalTabs - 1) {
					this.switchToTab(this.currentIndex + 1);
				}
			});
		}

		// Initialize arrow states
		this.updateArrowStates();
	}

	switchToTab(index) {
		if (index < 0 || index >= this.totalTabs) {
			return;
		}

		// Remove active class from all
		this.elements.$tabLinks.removeClass('active');
		this.elements.$tabContainers.removeClass('active');
		this.elements.$bgImages.removeClass('active');

		// Add active class to current
		this.elements.$tabLinks.eq(index).addClass('active');
		this.elements.$tabContainers.eq(index).addClass('active');
		if (this.elements.$bgImages.eq(index).length) {
			this.elements.$bgImages.eq(index).addClass('active');
		}

		this.currentIndex = index;
		this.updateArrowStates();
	}

	updateArrowStates() {
		if (this.elements.$prevBtn.length) {
			this.elements.$prevBtn.prop('disabled', this.currentIndex === 0);
		}
		if (this.elements.$nextBtn.length) {
			this.elements.$nextBtn.prop('disabled', this.currentIndex === this.totalTabs - 1);
		}
	}
}

jQuery(window).on('elementor/frontend/init', () => {
	elementorFrontend.elementsHandler.attachHandler(
		'hm_tabs_image_background',
		HoffmasterTabsImageBackgroundHandler
	);
});
